import { Spin } from "antd";
import React from "react";
import { Container } from "./styles";

interface CircularProgressProps {
  size?: any;
  margin?: string;
}

const CircularProgress = ({
  size = "default",
  margin,
}: CircularProgressProps) => {
  return (
    <Container margin={margin}>
      <Spin size={size} />
    </Container>
  );
};
export default CircularProgress;
